module.exports = __webpack_public_path__ + "static/media/07.4aa8ddf8.png";